import Model from "./model";

class BillingAddress extends Model {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();

    this._companyName = "";
    this._personInChargeName = "";
    this._postalCode = "";
    this._state = "";
    this._town = "";
    this._street = "";
    this._building = "";
    this._phoneNumber = "";
  }
  /* eslint-enable */

  get companyName() {
    return this._companyName;
  }

  set companyName(value) {
    this._companyName = value;
  }

  get personInChargeName() {
    return this._personInChargeName;
  }

  set personInChargeName(value) {
    this._personInChargeName = value;
  }

  get postalCode() {
    return this._postalCode;
  }

  set postalCode(value) {
    this._postalCode = value;
  }

  get state() {
    return this._state;
  }

  set state(value) {
    this._state = value;
  }

  get town() {
    return this._town;
  }

  set town(value) {
    this._town = value;
  }

  get street() {
    return this._street;
  }

  set street(value) {
    this._street = value;
  }

  get building() {
    return this._building;
  }

  set building(value) {
    this._building = value;
  }

  get phoneNumber() {
    return this._phoneNumber;
  }

  set phoneNumber(value) {
    this._phoneNumber = value;
  }

  getPostalCodeText() {
    let res = "";
    if (this.postalCode && this.postalCode.length >= 7) {
      const postalCodeNoHyphen = this.postalCode.replace("-", "");
      res = `${postalCodeNoHyphen.substring(0, 3)}-${postalCodeNoHyphen.substring(3)}`;
    }
    return res;
  }

  getAddressText() {
    return `${this._state}${this._town}${this._street} ${this._building}`;
  }

  json() {
    return {
      companyName: this._companyName,
      personInChargeName: this._personInChargeName,
      postalCode: this._postalCode,
      state: this._state,
      town: this._town,
      street: this._street,
      building: this._building,
      phoneNumber: this._phoneNumber,
    };
  }
}

class PaymentInfo extends Model {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();

    this._paymentMethod = "bank_transfer";
  }
  /* eslint-enable */

  get paymentMethod() {
    return this._paymentMethod;
  }

  set paymentMethod(value) {
    this._paymentMethod = value;
  }

  getPaymentMethodText() {
    if (this.paymentMethod === "bank_transfer") {
      return "銀行振込";
    }
    return "-";
  }

  json() {
    return {
      paymentMethod: this._paymentMethod,
    };
  }
}

class Organization extends Model {
  constructor() {
    super();

    this._organizationId = "";
    this._name = "";
    this._ownerUserId = "";
    this._ownerUserEmail = "";
    this._ownerUserName = "";

    this._billingAddress = new BillingAddress();
    this._paymentInfo = new PaymentInfo();

    this._spaceKey = "";
    this._planTypeCd = "";
    this._version = 0;
  }

  get organizationId() {
    return this._organizationId;
  }

  set organizationId(value) {
    this._organizationId = value;
  }

  get name() {
    return this._name;
  }

  set name(value) {
    this._name = value;
  }

  get ownerUserId() {
    return this._ownerUserId;
  }

  set ownerUserId(value) {
    this._ownerUserId = value;
  }

  get ownerUserEmail() {
    return this._ownerUserEmail;
  }

  set ownerUserEmail(value) {
    this._ownerUserEmail = value;
  }

  get ownerUserName() {
    return this._ownerUserName;
  }

  set ownerUserName(value) {
    this._ownerUserName = value;
  }

  get billingAddress() {
    return this._billingAddress;
  }

  set billingAddress(value) {
    this._billingAddress = value;
  }

  get paymentInfo() {
    return this._paymentInfo;
  }

  set paymentInfo(value) {
    this._paymentInfo = value;
  }

  get spaceKey() {
    return this._spaceKey;
  }

  set spaceKey(value) {
    this._spaceKey = value;
  }

  get planTypeCd() {
    return this._planTypeCd;
  }

  set planTypeCd(value) {
    this._planTypeCd = value;
  }

  get version() {
    return this._version;
  }

  set version(value) {
    this._version = value;
  }

  json() {
    const res = {
      serviceAccountId: this.serviceAccountId,
      serviceAccountName: this.serviceAccountName,
      contractUserId: this.contractUserId,
      contractUserEmail: this.contractUserEmail,
      contractUserName: this.contractUserName,
      spaceKey: this.spaceKey,
      planTypeCd: this.planTypeCd,
      version: this.version,
    };

    if (this._billingAddress instanceof BillingAddress) {
      res.billingAddress = this._billingAddress.json();
    }

    if (this._paymentInfo instanceof PaymentInfo) {
      res.paymentInfo = this._paymentInfo.json();
    }
    return res;
  }
}

export {
  BillingAddress,
  PaymentInfo,
  Organization,
};
